import { IsoLocale } from "./iso-locale"

export const PrivacyLinks = new Map<IsoLocale, string>([
  [IsoLocale.svSE, "https://zettle.com/se/sekretesspolicy"],
  [IsoLocale.svFI, "https://zettle.com/sv-fi/sekretesspolicy"],
  [IsoLocale.daDK, "https://zettle.com/dk/privatlivspolitik"],
  [IsoLocale.fiFI, "https://zettle.com/fi/yksityisyyden-suoja"],
  [IsoLocale.nbNO, "https://zettle.com/no/personvernerklaering"],
  [IsoLocale.enGB, "https://zettle.com/gb/legal/privacy-policy"],
  [IsoLocale.deDE, "https://zettle.com/de/die-datenschutzbestimmungen-akzeptieren"],
  [IsoLocale.esES, "https://zettle.com/es/politica-de-privacidad"],
  [IsoLocale.esMX, "https://zettle.com/mx/politica-de-privacidad"],
  [IsoLocale.ptBR, "https://zettle.com/br/politica-de-privacidade"],
  [IsoLocale.nlNL, "https://zettle.com/nl/privacybeleid"],
  [IsoLocale.frFR, "https://zettle.com/fr/politique-de-confidentialite"],
  [IsoLocale.itIT, "https://zettle.com/it/informativa-sulla-privacy"],
  [
    IsoLocale.enUS,
    "https://www.paypal.com/us/webapps/mpp/ua/privacy-full?locale.x=en_US",
  ],
  [
    IsoLocale.esUS,
    "https://www.paypal.com/us/webapps/mpp/ua/privacy-full?locale.x=es_US",
  ],
])
